import * as LucideIcons from "lucide-react";

interface DynamicIconProps {
  name: string;
  className?: string;
}

const DynamicIcon = ({ name, className }: DynamicIconProps) => {
  const LucideComponent = (LucideIcons as any)[name];

  if (!LucideComponent) return <span>⚠️ Icon Not Found</span>; // Fallback for invalid icon names

  return <LucideComponent className={className} />;
};

export default DynamicIcon